import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrAiIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23 15H16.41L13.1 11.69L14.02 8H16.99C17.54 8 17.99 7.55 17.99 7V1C18 0.45 17.55 0 17 0H11C10.45 0 10 0.45 10 1V7C10 7.55 10.45 8 11 8H11.97L11.18 11.18L8 11.97V11C8 10.45 7.55 10 7 10H1C0.45 10 0 10.45 0 11V17C0 17.55 0.45 18 1 18H7C7.55 18 8 17.55 8 17V14.03L11.69 13.11L15 16.42V23.01C15 23.56 15.45 24.01 16 24.01H23C23.55 24.01 24 23.56 24 23.01V16.01C24 15.46 23.55 15.01 23 15.01V15ZM12 2H16V6H12V2ZM6 16H2V12H6V16ZM22 22H17V17H22V22Z" fill={color}/>
  </BaseIcon>
));

AttrAiIcon.displayName = 'AttrAiIcon';
